<template>
  <div style="padding-top:50px;" class="mobileTop">
    <div>
      <!-- <b-row v-for="(month, index) in months" :key="index" class="monthBreakBack">
        <b-container>
          <span class="monthBreak">{{month.name.substring(0,3)}} {{new Date().getFullYear()}}</span>
        </b-container>
      </b-row> -->
      <Schedule
        :id="id"
        :fields="fields"
        :data="data"
        :code="code"
        :config="config"
        :loggedin="loggedin"
        :course="course"
        :idName="idName"
        :future="future"
        :past="past"
      />
    </div>
  </div>
</template>

<script>
import { Schedule } from "@ocs-software/vue-ocs";
export default {
  name: "scheduleTable",
  props: ["id", "fields", "data", "loggedin", "course", "idName", "config"],
  components: {
    Schedule
  },
  data() {
    return {
      box: "box",
      months: [
        {
          name: "January",
          month: "1",
          tourn: ""
        },
        {
          name: "February",
          month: "2",
          tourn: ""
        },
        {
          name: "March",
          month: "3",
          tourn: ""
        },
        {
          name: "April",
          month: "4",
          tourn: ""
        },
        {
          name: "May",
          month: "5",
          tourn: ""
        },
        {
          name: "June",
          month: "6",
          tourn: ""
        },
        {
          name: "July",
          month: "7",
          tourn: ""
        },
        {
          name: "August",
          month: "8",
          tourn: ""
        },
        {
          name: "September",
          month: "9",
          tourn: ""
        },
        {
          name: "October",
          month: "10",
          tourn: ""
        },
        {
          name: "November",
          month: "11",
          tourn: ""
        },
        {
          name: "December",
          month: "12",
          tourn: ""
        }
      ],
      future: true,
      past: true,
      test: ""
    };
  },
  methods: {
    dontknow: function() {
      var data = this.data;
      if (this.future == true) {
        console.log("True");
        data.forEach(value => {
          if (value.days_away > 0 && value.dates.includes("January")) {
            this.test = "DontShowMonth";
          }
        });
        return this.test;
      }
    }
  },
  computed: {
    filter() {
      return [
        ...new Map(
          this.data.map(item => [item.days_away.includes(this.month), item])
        ).values()
      ];
    }
  }
  // mounted() {
  //   this.dontknow();
  // }
};
</script>

<style scoped>
</style>
<style scoped src="@/css/schedule.css"></style>